module.exports = __webpack_public_path__ + "static/media/bsessid-wide.c61780fe.png";